import { defineMessage, msg } from '@lingui/core/macro';
import { CategoryConstantType, CategoryEnum } from '@/@types';

import * as subcategories from './subcategories';

export { subcategories };

export const mediaProviders = [
  { id: 'netflix', name: 'netflix', title: 'Netflix', url: '' },
  { id: 'disney', name: 'disney', title: 'Disney Plus', url: '' },
  { id: 'prime_video', name: 'primevideo', title: 'Amazon Prime', url: '' },
  { id: 'movistar', name: 'movistar', title: 'Movistar Plus', url: '' },
  { id: 'hbo', name: 'hbo', title: 'HBO', url: '' },
  { id: 'filmin', name: 'filmin', title: 'Filmin', url: '' },
  { id: 'apple', name: 'apple-tv', title: 'Apple TV', url: '' },
  // { id: 'justWatch', name: 'justwatch', title: 'Just Watch' },
] as { id: string; name: string; title: string; url: string }[];

export const providers = {
  movies: mediaProviders,
  series: mediaProviders,
};

export const categories = {
  movies: {
    id: '10',
    name: 'movies',
    title: msg`Movies`,
    _subcategoriesId: ['18'],
    active: true,
    itemTitle: msg`Movie`,
    description: msg`Explore top movies picks from the Peoople community, with options across platforms and genres.`,
  },
  series: {
    id: '10',
    name: 'series',
    title: msg`Series`,
    _subcategoriesId: ['94'],
    active: true,
    itemTitle: msg`Serie`,
    description: msg`Explore top series picks from the Peoople community, with options across platforms and genres.`,
  },
  restaurants: {
    id: '8',
    name: 'restaurants',
    title: msg`Restaurants`,
    _subcategoriesId: ['8', '42', '66', '67', '70', '72', '82', '83', '84', '85', '86', '87', '88', '89', '135', '144'],
    active: true,
    itemTitle: msg`Restaurants`,
    description: msg`Discover community-recommended restaurants on Peoople, offering a variety of cuisines and locations.`,
  },
  music: {
    id: '10',
    name: 'music',
    title: defineMessage({
      id: 'music category name',
      message: 'Music',
      comment: 'Music category name, because it could translate better to song on spanish is handled differently',
    }),
    _subcategoriesId: ['23'],
    active: true,
    itemTitle: defineMessage({
      id: 'music category item name',
      message: 'Music',
      comment: 'Music Item name, how individual items on this category will be refered',
    }),
    description: msg`Explore popular songs recommended by the Peoople community, available on platforms like Spotify and Apple Music.`,
  },
  videogames: {
    id: '10',
    name: 'videogames',
    title: msg`Videogames`,
    _subcategoriesId: ['92'],
    active: true,
    itemTitle: msg`Videogames`,
    description: msg`Discover top video game picks from the Peoople community, with options across platforms and genres.`,
  },
  apps: {
    id: '10',
    name: 'apps',
    title: msg`Apps`,
    _subcategoriesId: ['90'],
    active: true,
    itemTitle: msg`App`,
    description: msg`Discover popular apps recommended by the Peoople community, across different categories and platforms.`,
  },
  books: {
    id: '1',
    name: 'books',
    title: msg`Books`,
    _subcategoriesId: ['50'],
    active: true,
    itemTitle: msg`Book`,
    description: msg`Explore a curated selection of community-recommended books on Peoople, spanning diverse genres and categories.`,
  },
  electronics: {
    id: '1',
    name: 'electronics',
    title: msg`Electronics`,
    _subcategoriesId: ['51'],
    active: true,
    itemTitle: msg`Electronic`,
    description: msg`Browse community-recommended electronics on Peoople, including gadgets, devices, and more.`,
  },
  games: {
    id: '1',
    name: 'games',
    title: msg`Games`,
    _subcategoriesId: ['150'],
    active: true,
    itemTitle: msg`Game`,
    description: msg`Explore a variety of games recommended by the Peoople community, available on different platforms and across genres.`,
  },
  fashion: {
    id: '1',
    name: 'fashion',
    title: msg`Fashion`,
    _subcategoriesId: ['15', '96'],
    active: true,
    itemTitle: msg`Fashion`,
    description: msg`Discover a selection of fashion products recommended by the Peoople community, including clothing, accessories, and more.`,
  },
  fitness: {
    id: '1',
    name: 'fitness',
    title: msg`Fitness`,
    _subcategoriesId: ['138'],
    active: true,
    itemTitle: msg`Fitness`,
    description: msg`Explore fitness essentials recommended by the Peoople community, from equipment and activewear to accessories.`,
  },
  home: {
    id: '1',
    name: 'home',
    title: msg`Home Category`,
    _subcategoriesId: ['99'],
    active: true,
    itemTitle: msg`Home category item`,
    description: msg`Discover Peoople-recommended home products, including decor, furniture, and accessories.`,
  },
  beauty: {
    id: '1',
    name: 'beauty',
    title: msg`Beauty`,
    _subcategoriesId: ['100'],
    active: true,
    itemTitle: msg`Beauty`,
    description: msg`Explore beauty picks recommended by the Peoople community, from makeup to skincare and more.`,
  },
  places: {
    id: '4',
    name: 'places',
    title: msg`Places`,
    _subcategoriesId: [
      '1',
      '9',
      '10',
      '11',
      '12',
      '13',
      '21',
      '79',
      '103',
      '104',
      '105',
      '107',
      '119',
      '121',
      '124',
      '125',
      '126',
      '131',
      '133',
      '137',
      '139',
      '146',
      '35',
      '36',
      '39',
      '40',
      '136',
      '142',
    ],
    active: true,
    itemTitle: msg`Place`,
    description: msg`Discover top destinations recommended by the Peoople community, from tourist spots and restaurants to cafés and other attractions.`,
  },
  products: {
    id: '1',
    name: 'products',
    title: msg`Products`,
    _subcategoriesId: ['16', '52', '54', '101', '140', '149'],
    active: false,
    itemTitle: msg`Product`,
  },
  social: {
    id: '',
    name: 'social',
    title: msg`Social`,
    _subcategoriesId: [''],
    active: false,
    itemTitle: msg`Social`,
  },
} as {
  // eslint-disable-next-line no-unused-vars
  [x in CategoryEnum]: CategoryConstantType;
};

export const gamification = {
  0: {
    name: 'Rookie',
    emoji: '🍦',
    index: 0,
  },
  '0.5': {
    name: 'Creator',
    emoji: '🌱',
    index: 0.5,
  },
  1: {
    name: 'Influencer',
    emoji: '💙',
    index: 1,
  },
  2: {
    name: 'Unicorn',
    emoji: '🦄',
    index: 2,
  },
  3: {
    name: 'Star',
    emoji: '⭐️',
    index: 3,
  },
};

export const findCategory = (categoryName: string) => {
  return Object.values(categories).find((category) => {
    return category.name === categoryName;
  });
};

export const findCategoryBySubCategory = (subcategoriesId: string) => {
  const cat = Object.values(categories).find((category) => {
    return category._subcategoriesId.includes(subcategoriesId);
  }) as CategoryConstantType;
  if (!cat) {
    return categories.products;
  }
  return cat;
};
